import {EVENT_MOUNTED, Splide} from "@splidejs/splide";

export function UpdateSplideArrows( Splide, Components, options ) {
    /**
     * Optional. Called when the component is mounted.
     */
    function mount() {}

    // Listen for the EVENT_MOUNTED event
    Splide.on(EVENT_MOUNTED, () => {
        updateArrowsHeight();
    });

    function updateArrowsHeight() {
        const { list} = Components.Elements;
        const leftArrow = Components.Arrows.arrows.prev;
        const rightArrow = Components.Arrows.arrows.next;
        const arrowsArray = [leftArrow, rightArrow];
        if (list && leftArrow && rightArrow && arrowsArray) {
            const updateArrowHeight = () => {
                const listHeight = list.offsetHeight;
                arrowsArray.forEach(arrow => {
                    arrow.style.height = `${listHeight}px`;
                });
            };

            // Update arrow height on load and on window resize
            updateArrowHeight();
        }
    }
    /**
     * Optional. Called when the Splide destroys the carousel.
     */
    function destroy() {}

    return {
        mount,
        destroy,
    };
}
